import React, { useMemo } from 'react';
import classNames from 'classnames';
import { formatPercentage } from 'utils';

import './ProgressBar.styles.scss';

type ProgressBarProps = {
  className?: string;
  percentage: number;
  withText?: boolean;
};

const ProgressBar: React.FC<ProgressBarProps> = (props) => {
  const { className, percentage, withText } = props;

  const formattedValue = useMemo(
    () => formatPercentage(percentage),
    [percentage],
  );

  const classes = classNames(
    'progress-bar',
    { 'with-text': withText },
    className,
  );

  return (
    <div
      className={classes}
      aria-label="Progress bar."
      role="progressbar"
      aria-valuemin={0}
      aria-valuemax={100}
      aria-valuenow={percentage}
      aria-valuetext={formattedValue}
      data-percentage={formattedValue}
      style={
        { '--progress-percentage': formatPercentage(percentage - 100) } as React.CSSProperties
      }
    />
  );
};

export default ProgressBar;
